<template>
  <section
    v-if="isVisible"
    class="app-web-promo hidden xl:block"
    aria-label="Мобильное приложение"
  >
    <div v-if="hasPromoCard" class="app-web-promo__card">
        <div v-if="phoneImageUrl" class="app-web-promo__visual">
          <img
            :src="phoneImageUrl"
            alt=""
            class="app-web-promo__phone-img"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div class="app-web-promo__body">
          <h2 class="app-web-promo__title">
            {{ promoTitle }}
          </h2>

          <div v-if="hasStoreLinks" class="app-web-promo__stores">
            <a
              v-if="appStoreUrl"
              :href="appStoreUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="app-web-promo__store-link"
            >
              <span class="app-web-promo__store-icon app-web-promo__store-icon--apple" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
              </span>
              <span class="app-web-promo__store-label">App Store</span>
            </a>

<!--            <a-->
<!--              v-if="googlePlayUrl"-->
<!--              :href="googlePlayUrl"-->
<!--              target="_blank"-->
<!--              rel="noopener noreferrer"-->
<!--              class="app-web-promo__store-link"-->
<!--            >-->
<!--              <span class="app-web-promo__store-icon app-web-promo__store-icon&#45;&#45;gplay" aria-hidden="true">-->
<!--                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">-->
<!--                  <path d="M3 20.5v-17c0-.59.34-1.11.88-1.35L13.12 12 3.88 21.85A1.5 1.5 0 0 1 3 20.5zm13.03-9.34L5.88 3.15 14.97 12l-8.9 8.85 10.15-5.86c.65-.38 1.05-1.08 1.05-1.84s-.4-1.46-1.05-1.84zM16.5 9.9l3.42-1.98A1.5 1.5 0 0 1 22 9.16v5.68a1.5 1.5 0 0 1-2.08 1.24L16.5 14.1V9.9z"/>-->
<!--                </svg>-->
<!--              </span>-->
<!--              <span class="app-web-promo__store-label">Google Play</span>-->
<!--            </a>-->

            <!-- RuStore: отдельной ссылки/URL в institution нет — google_play_url
                 задокументирован как «Google Play / RuStore», поэтому ведём на него же. -->
            <a
              v-if="googlePlayUrl"
              :href="googlePlayUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="app-web-promo__store-link"
            >
              <span class="app-web-promo__store-icon app-web-promo__store-icon--rustore" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <text x="12" y="17" text-anchor="middle" font-size="15" font-weight="700" font-family="Arial, sans-serif">R</text>
                </svg>
              </span>
              <span class="app-web-promo__store-label">RuStore</span>
            </a>
          </div>

          <ul class="app-web-promo__features">
            <li>Быстрая оплата</li>
            <li>Уведомления о заказе</li>
            <li v-if="cashbackText">{{ cashbackText }}</li>
            <li>Карта лояльности</li>
          </ul>
        </div>

        <div v-if="qrImageUrl" class="app-web-promo__qr-wrap">
          <img
            :src="qrImageUrl"
            alt="QR-код для установки приложения"
            class="app-web-promo__qr"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>

      <!-- Контакт-строка: логотип слева, телефон / часы / выбор филиала справа.
           Селект филиала показываем только если филиалов больше одного. -->
      <div v-if="hasContacts" class="app-web-promo__contacts">
        <a v-if="logoUrl" href="/" class="app-web-promo__logo" aria-label="На главную">
          <img :src="logoUrl" alt="" loading="lazy" decoding="async" />
        </a>
        <span v-else />

        <div class="app-web-promo__contacts-right">
          <a v-if="currentPhone" :href="telHref" class="app-web-promo__phone">
            {{ currentPhone }}
          </a>
          <div class="app-web-promo__hours-row">
            <span v-if="hoursText" class="app-web-promo__hours">{{ hoursText }}</span>
            <div v-if="hasMultipleBranches" class="app-web-promo__branch">
              <UiKitSelect
                size="md"
                variant="flat"
                :options="branchSelectOptions"
                :model-value="store.selectedBranchId"
                @update:model-value="onSelectBranch"
              />
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useInstitutionStore } from '@entities/institution'
import { PlatformHelper } from '@shared/lib'

const store = useInstitutionStore()

// Блок показываем ТОЛЬКО на сайте. В нативном приложении (iOS/Android) скрываем —
// там магазины приложений не нужны. isCapacitor() === Capacitor.isNativePlatform()
// (true на iOS/Android, false в вебе), проверка только на клиенте.
const hideOnNative = ref(false)

onMounted(() => {
  if (PlatformHelper.isCapacitor()) {
    hideOnNative.value = true
  }
})

// Картинки промо хранятся в visual.params_json (без миграции БД), с фолбэком
// на исторические top-level поля institution.
const promoParams = computed(() => (store.institution as any)?.visual?.params_json ?? {})
const phoneImageUrl = computed(
  () =>
    (promoParams.value?.web_app_promo_phone_image_url
      || store.institution?.web_app_promo_phone_image_url
      || '').trim(),
)
const qrImageUrl = computed(
  () =>
    (promoParams.value?.web_app_install_qr_image_url
      || store.institution?.web_app_install_qr_image_url
      || '').trim(),
)
const appStoreUrl = computed(() => store.institution?.app_store_url?.trim() || '')
const googlePlayUrl = computed(() => store.institution?.google_play_url?.trim() || '')

// Кэшбэк-пункт показываем динамически: берём МАКСИМАЛЬНЫЙ процент из настроек
// программы лояльности (финальный диапазон/верхний уровень). Уровни уже лежат
// в institution (loyalty_levels) — публично, без отдельного авторизованного
// запроса. Если лояльность выключена/уровней нет — пункт скрываем (форма как в
// макете: 3 пункта).
const loyaltyEnabled = computed(() => Boolean((store.institution as any)?.loyalty_enabled))
const maxCashbackPercent = computed(() => {
  if (!loyaltyEnabled.value) return 0
  const levels = ((store.institution as any)?.loyalty_levels ?? []) as Array<{ percent?: string | number }>
  const values = levels
    .map(level => Number(level?.percent))
    .filter(value => Number.isFinite(value) && value > 0)
  if (!values.length) return 0
  const max = Math.max(...values)
  // percent приходит долей (0.07 = 7%) → переводим в проценты. Защита на случай,
  // если где-то уже хранится целым (7): доли (<1) умножаем, целые оставляем.
  const percent = max < 1 ? max * 100 : max
  return Math.round(percent * 100) / 100
})
const cashbackText = computed(() =>
  maxCashbackPercent.value > 0 ? `Кэшбэк до ${maxCashbackPercent.value}% баллами` : '',
)

const institutionName = computed(() => store.institution?.name?.trim() || '')

const promoTitle = computed(() =>
  institutionName.value
    ? `Скачайте приложение ${institutionName.value}`
    : 'Скачайте наше приложение',
)

// ---- Контакт-строка (логотип / телефон / часы / выбор филиала) ----
const logoUrl = computed(() => ((store.institution as any)?.visual?.logo_file || '').trim())
const currentPhone = computed(() => store.currentCity?.phone?.trim() || '')
const telHref = computed(() => `tel:${currentPhone.value.replaceAll(/[^\d+]/g, '')}`)
const workingHours = computed(() => store.currentCity?.working_hours?.hours?.trim() || '')
const hoursText = computed(() => (workingHours.value ? `Ежедневно: ${workingHours.value}` : ''))
const hasMultipleBranches = computed(() => store.branchOptions.length > 1)
// Опции для UiKitSelect: { label: «Улица, Станица», value: id }
const branchSelectOptions = computed(() =>
  store.branchOptions.map((o) => ({ label: o.label, value: o.id })),
)
function onSelectBranch(value: string | number | (string | number)[] | null) {
  store.chooseBranch(value == null ? null : Number(value))
}

const hasPromoAssets = computed(() => Boolean(phoneImageUrl.value || qrImageUrl.value))
const hasStoreLinks = computed(() => Boolean(appStoreUrl.value || googlePlayUrl.value))
const hasContacts = computed(() => Boolean(logoUrl.value || currentPhone.value || hoursText.value))

// Блок (карточка + контакт-строка) показываем только при наличии промо-ассетов
// — как в макете они идут вместе. Без промо-картинок поведение прежнее (пусто).
const hasPromoCard = hasPromoAssets
const isVisible = computed(
  () => !hideOnNative.value && hasPromoCard.value,
)
</script>

<style scoped lang="scss">
.app-web-promo {
  @apply w-full mb-8 pt-80;


  &__card {
    // overflow: visible — чтобы телефон «вылезал» за верхнюю границу карточки.
    // Низ телефона при этом обрезается через overflow на самой колонке (&__visual).
    @apply relative flex flex-row items-stretch rounded-[32px];
    background: #f4f4f5;
    min-height: 248px;
    overflow: visible;
    padding-left: 21.5rem;

    .dark & {
      @apply bg-zinc-800;
    }
  }

  // Левая колонка вынесена из потока (absolute), под неё зарезервирован
  // padding-left у карточки. Верх уходит выше карточки (top отрицательный),
  // низ строго по нижней грани (bottom: 0) + overflow:hidden → обрезка снизу.
  &__visual {
    @apply absolute overflow-hidden;
    left: 1.5rem;
    top: -170px;
    bottom: 0;
    width: 19rem;
    pointer-events: none;
  }

  &__phone-img {
    @apply absolute top-0 left-0 w-full h-auto;
    object-fit: contain;
  }

  &__body {
    @apply flex-1 flex flex-col justify-center min-w-0 py-8 pr-6;
  }

  &__title {
    @apply text-[28px] leading-tight font-bold text-gray-900 tracking-tight mb-5;

    .dark & {
      @apply text-white;
    }
  }

  &__stores {
    @apply flex flex-row flex-wrap items-center gap-x-6 gap-y-3 mb-6;
  }

  &__store-link {
    @apply inline-flex items-center gap-2 text-base font-medium text-gray-900 transition-opacity;
    @apply hover:opacity-70 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500 rounded;

    .dark & {
      @apply text-white;
    }
  }

  &__store-icon {
    @apply inline-flex flex-shrink-0 items-center justify-center w-6 h-6 rounded-md text-white;

    svg {
      @apply w-4 h-4;
    }

    &--apple {
      background: #0070c9;
    }

    &--gplay {
      background: #0f9d58;
    }

    &--rustore {
      background: linear-gradient(135deg, #0a84ff 0%, #2ed3ff 100%);
    }
  }

  &__store-label {
    @apply leading-none;
  }

  &__features {
    @apply list-disc pl-5 space-y-2 text-base text-gray-600 mb-0;

    .dark & {
      @apply text-zinc-300;
    }
  }

  &__qr-wrap {
    // Белые паддинги вокруг QR (≈24px) + белый фон — как в макете.
    @apply flex-shrink-0 self-center ml-4 mr-8 rounded-2xl bg-white;
    padding: 24px;
  }

  &__qr {
    @apply block object-contain;
    width: 160px;
    height: 160px;
  }

  // ---- Контакт-строка ----
  &__contacts {
    @apply flex flex-row items-center justify-between gap-6 pt-8;
  }

  &__logo {
    @apply flex items-center;

    img {
      @apply h-12 w-auto max-w-[220px] object-contain;
    }
  }

  &__contacts-right {
    @apply flex flex-col items-end gap-1 text-right;
  }

  &__phone {
    @apply text-xl font-semibold text-gray-900 transition-opacity hover:opacity-70;

    .dark & {
      @apply text-white;
    }
  }

  &__hours-row {
    @apply flex items-center gap-3;
  }

  &__branch {
    @apply w-[340px] max-w-full shrink-0;
  }

  &__hours {
    @apply text-sm text-gray-500;

    .dark & {
      @apply text-zinc-400;
    }
  }
}

@media (min-width: 1280px) and (max-width: 1439px) {
  .app-web-promo__card {
    padding-left: 17rem;
  }

  .app-web-promo__visual {
    width: 15rem;
    left: 1rem;
    top: -24px;
  }

  .app-web-promo__title {
    @apply text-2xl;
  }

  .app-web-promo__qr {
    width: 132px;
    height: 132px;
  }
}
</style>
